import React from 'react';
import { isEmpty, kebabCase } from 'lodash';
import { motion } from 'framer-motion';
import BoxedContainer from '../layouts/BoxedContainer';
import Button from '../layouts/Button';

export default function IntroText({ data }) {
  const { title, htmlContent, link, fontSm } = data;
  return (
    <section
      className="lg:-mt-[80px] -mt-[20px] bg-white lg:pt-[175px] pt-[80px] lg:pb-[118px]
      pb-[80px]"
    >
      <BoxedContainer className="regular">
        <div className="flex lg:flex-row flex-col 2xl:gap-x-[82px] gap-x-[60px] lg:gap-y-0 gap-y-4">
          {isEmpty(title) || (
            <motion.h3
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.4 }}
              viewport={{ once: true }}
              className={`lg:w-[36%] lg:min-w-[36%] text-primary font-roboto-condensed-bold
              lg:text-[38px] lg:leading-[55px] text-[28px] leading-[40px] uppercase
              ${fontSm ? '2xl:text-[42px] 2xl:leading-[58px]' : '2xl:text-2xl'}`}
              dangerouslySetInnerHTML={{ __html: title }}
            />
          )}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.6 }}
            viewport={{ once: true }}
            className="flex flex-col 2xl:gap-y-[58px] lg:gap-y-11 gap-y-8"
          >
            {isEmpty(htmlContent) || (
              <p
                className="2xl:text-base text-[15px] leading-6 text-primary font-roboto-regular
              flex flex-col gap-y-4"
                dangerouslySetInnerHTML={{ __html: htmlContent }}
              />
            )}
            {isEmpty(link) || (
              <Button
                url={link.url}
                label={link.name}
                ariaLabel={link.name}
                tagName={kebabCase(link.name)}
                variant="primaryRed"
                text="md:w-[285px] !w-fit md:min-w-[max-content] px-[24px]"
              />
            )}
          </motion.div>
        </div>
      </BoxedContainer>
    </section>
  );
}
